import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_nuxtgooglemaps_718d8f4d from 'nuxt_plugin_nuxtgooglemaps_718d8f4d' // Source: ./nuxt-google-maps.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_2ec31ef2 from 'nuxt_plugin_cookieuniversalnuxt_2ec31ef2' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_moment_b4beb0e4 from 'nuxt_plugin_moment_b4beb0e4' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_libplugin770c42c4_c6076ce8 from 'nuxt_plugin_libplugin770c42c4_c6076ce8' // Source: ./lib.plugin.770c42c4.js (mode: 'all')
import nuxt_plugin_workbox_6d03c434 from 'nuxt_plugin_workbox_6d03c434' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_22e61ef9 from 'nuxt_plugin_metaplugin_22e61ef9' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_278dc46d from 'nuxt_plugin_iconplugin_278dc46d' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_apollomodule_02bd3516 from 'nuxt_plugin_apollomodule_02bd3516' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_toast_2be59ff9 from 'nuxt_plugin_toast_2be59ff9' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_5fb5534a from 'nuxt_plugin_axios_5fb5534a' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_axios_630a4306 from 'nuxt_plugin_axios_630a4306' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_bugsnag_4aea807c from 'nuxt_plugin_bugsnag_4aea807c' // Source: ../plugins/bugsnag (mode: 'all')
import nuxt_plugin_directives_f60b4746 from 'nuxt_plugin_directives_f60b4746' // Source: ../plugins/directives (mode: 'all')
import nuxt_plugin_filters_0a501042 from 'nuxt_plugin_filters_0a501042' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_fontawesome_5e0b9dfb from 'nuxt_plugin_fontawesome_5e0b9dfb' // Source: ../plugins/fontawesome (mode: 'all')
import nuxt_plugin_form_d9e34446 from 'nuxt_plugin_form_d9e34446' // Source: ../plugins/form (mode: 'all')
import nuxt_plugin_config_56e5e2e6 from 'nuxt_plugin_config_56e5e2e6' // Source: ../plugins/mixins/config (mode: 'all')
import nuxt_plugin_validation_b46593c6 from 'nuxt_plugin_validation_b46593c6' // Source: ../plugins/mixins/validation (mode: 'all')
import nuxt_plugin_vuelazysizesclient_c150bd08 from 'nuxt_plugin_vuelazysizesclient_c150bd08' // Source: ../plugins/vue-lazysizes.client.js (mode: 'client')
import nuxt_plugin_vtooltip_41415433 from 'nuxt_plugin_vtooltip_41415433' // Source: ../plugins/v-tooltip (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Mijn Superkracht","titleTemplate":(t) => {
      return t + (t === 'Mijn Superkracht' ? '' : ' – Mijn Superkracht');
    },"htmlAttrs":{"lang":"nl"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","hid":"description","content":""},{"name":"apple-mobile-web-app-title","hid":"apple-mobile-web-app-title","content":"Mijn Superkracht"},{"name":"og:title","hid":"og:title","content":"Mijn Superkracht"},{"name":"og:description","hid":"og:description","content":""},{"name":"og:site_name","hid":"og:site_name","content":"Mijn Superkracht"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Fuse.typekit.net\u002Fubr4ano.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_nuxtgooglemaps_718d8f4d === 'function') {
    await nuxt_plugin_nuxtgooglemaps_718d8f4d(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_2ec31ef2 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_2ec31ef2(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_b4beb0e4 === 'function') {
    await nuxt_plugin_moment_b4beb0e4(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin770c42c4_c6076ce8 === 'function') {
    await nuxt_plugin_libplugin770c42c4_c6076ce8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6d03c434 === 'function') {
    await nuxt_plugin_workbox_6d03c434(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_22e61ef9 === 'function') {
    await nuxt_plugin_metaplugin_22e61ef9(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_278dc46d === 'function') {
    await nuxt_plugin_iconplugin_278dc46d(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_02bd3516 === 'function') {
    await nuxt_plugin_apollomodule_02bd3516(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_2be59ff9 === 'function') {
    await nuxt_plugin_toast_2be59ff9(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5fb5534a === 'function') {
    await nuxt_plugin_axios_5fb5534a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_630a4306 === 'function') {
    await nuxt_plugin_axios_630a4306(app.context, inject)
  }

  if (typeof nuxt_plugin_bugsnag_4aea807c === 'function') {
    await nuxt_plugin_bugsnag_4aea807c(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_f60b4746 === 'function') {
    await nuxt_plugin_directives_f60b4746(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_0a501042 === 'function') {
    await nuxt_plugin_filters_0a501042(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_5e0b9dfb === 'function') {
    await nuxt_plugin_fontawesome_5e0b9dfb(app.context, inject)
  }

  if (typeof nuxt_plugin_form_d9e34446 === 'function') {
    await nuxt_plugin_form_d9e34446(app.context, inject)
  }

  if (typeof nuxt_plugin_config_56e5e2e6 === 'function') {
    await nuxt_plugin_config_56e5e2e6(app.context, inject)
  }

  if (typeof nuxt_plugin_validation_b46593c6 === 'function') {
    await nuxt_plugin_validation_b46593c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazysizesclient_c150bd08 === 'function') {
    await nuxt_plugin_vuelazysizesclient_c150bd08(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vtooltip_41415433 === 'function') {
    await nuxt_plugin_vtooltip_41415433(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    const { route } = router.resolve(app.context.route.fullPath)
    // Ignore 404s rather than blindly replacing URL
    if (!route.matched.length && process.client) {
      return resolve()
    }
    router.replace(route, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
